<template>
<div class="mypage_common">
  <div class="common_head">
      <h5>환불계좌관리</h5>
  </div>
  <div class="common_body">
      <div class="tbl_wrap">
          <table class="write refund">
              <tbody>
                  <tr>
                      <th>
                          예금주
                      </th>
                      <td>
                          <input type="text" v-model="bankOwner">
                      </td>
                  </tr>
                  <tr>
                      <th>
                          은행명
                      </th>
                      <td>
                          <SelectList v-model="bankName" :options="bankOptions" unit="" selectClass="select_box"/>
                      </td>
                  </tr>
                  <tr>
                      <th>
                          계좌번호
                      </th>
                      <td>
                          <div class="wrapper">
                              <input type="text" v-model="bankNumber">
                              <p>계좌번호는 ‘-’ 없이 입력해주세요.</p>
                          </div>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      <ul class="refund_txt">
          <li><span>·</span> 고객님께서 현금 결제한 주문을 취소하실 경우 수령하실 계좌입니다. 가입된 계좌로 현금결제 취소금액이 환불되오니 정확이 입력하시기 바랍니다.</li>
          <li><span>·</span> 환불을 위해 고객님의 은행명, 계좌번호, 예금주 명을 수집하고 있으며, 해당정보는 환불 이외에 사용되지 않습니다.</li>
          <li><span>·</span> 해당 정보는 동의 철회(삭제)시 또는 <b>수집일로부터 1년 후 자동 파기</b> 됩니다.</li>
          <li><span>·</span> 환불계좌는 <b>한국에서 개설한 은행 및 본인명의 계좌만 등록/변경</b> 가능합니다. 예금주 명과 회원정보의 성명이 다른 경우는 등록/변경되지 않습니다.</li>
      </ul>
      <div class="btn_wrap">
          <button type="button" class="btn_cancel" @click="toMyPage">취소</button>
          <button type="button" class="btn_delete" @click="deleteReturnBank">삭제</button>
          <button type="button" class="btn_check" @click="registerReturnBank">확인</button>
      </div>
  </div>
</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import SelectList from '@/components/common/SelectList.vue';

const accountModule = 'accountModule'

export default {
  components: {
    SelectList
  },

  data () {
    return {
      currentPage: 1,
      bankName: '은행선택',
      bankOwner: '',
      bankNumber: '',
      bankOptions: [
        '국민은행',
        '기업은행',
        '우리은행',
        '신한은행',
        '하나은행',
        '농협은행',
        '수협은행',
        '카카오뱅크',
        '케이뱅크',
        '토스뱅크',
        'SC제일은행',
        '씨티은행',
        '부산은행',
        '경남은행',
        '대구은행',
        '광주은행',
        '전북은행',
        '제주은행',
        '산업은행',
        '저축은행',
        '새마을금고',
        '신협',
        '우체국'
      ]

    }
  },
  methods: {
    ...mapActions(accountModule, [
        'requestRegisterReturnBank',
        'requestReturnBankInfo',
        'requestDeleteReturnBank'
    ]),

    async registerReturnBank() {
        const {bankName, bankOwner, bankNumber} = this
        const result = await this.requestRegisterReturnBank({bankName, bankOwner, bankNumber})
        this.$openModal('alertModal', {
            message: result
        })
        this.getReturnBankInfo()
    },

    async getReturnBankInfo() {
        const bankInfo = await this.requestReturnBankInfo()
        this.bankOwner = bankInfo.bankOwner
        this.bankNumber = bankInfo.bankNumber
        this.bankName = bankInfo.bankName
    },

    async deleteReturnBank() {
        const result = await this.requestDeleteReturnBank()
        this.$openModal('alertModal', {
            message: result
        })
        await this.getReturnBankInfo()
        this.bankName = '은행선택'
    },

    toMyPage() {
        this.$router.push({ name: 'MyPage'})
    }
  },

  async mounted() {
    await this.getReturnBankInfo()
    if (this.bankName === '' || this.bankName === null) {
        this.bankName = '은행선택'
    }
  }
}
</script>